import {BillingStateModel} from './billing-state.model';
import {Action, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {
  GetBillingTvOwnerOperations, GetTvOwnerBalance,
  SearchBillingOperationsTvOwner,
  SetBillingPageTvOwner,
  SortBillingOperationsTvOwner
} from '@store/billing/billing.actions';
import {Observable, throwError} from 'rxjs';
import {BillingService} from '@services/billing/billing.service';
import {catchError, tap} from 'rxjs/operators';

@State<BillingStateModel>({
  name: 'billingStateTvOwner',
  defaults: {
    currentPage: 1,
    searchParam: '',
    sort: 'id',
    order: 'DESC',
    itemsPerPage: 10,
    loader: false,
    operations: null,
    balance: 0,
  }
})

@Injectable({
  providedIn: 'root'
})

export class BillingState {
  constructor(private billingService: BillingService) {
  }

  @Action(GetBillingTvOwnerOperations, {cancelUncompleted: true})
  getBillingTvOwnerOperations(ctx: StateContext<BillingStateModel>): Observable<any> {
    const limit = ctx.getState().itemsPerPage;
    const skip = limit * (ctx.getState().currentPage - 1);
    const search = ctx.getState().searchParam;
    const order = ctx.getState().order;
    const sort = ctx.getState().sort;

    ctx.patchState({loader: true});
    return this.billingService.getTvOwnerOperations({limit, skip, search, sort, order})
      .pipe(
        tap((operations) => {
          const state = ctx.getState();
          ctx.setState({...state, operations, loader: false});
        }),
        catchError((error) => {
          ctx.patchState({loader: false});
          return throwError(error);
        })
      );
  }

  @Action(SearchBillingOperationsTvOwner)
  searchBillingOperationsTvOwner(ctx: StateContext<BillingStateModel>, {value}: SearchBillingOperationsTvOwner): Observable<void> {
    ctx.patchState({searchParam: value, currentPage: 1});
    return ctx.dispatch(new GetBillingTvOwnerOperations());
  }

  @Action(SortBillingOperationsTvOwner)
  sortBillingOperationsTvOwner(ctx: StateContext<BillingStateModel>, {payload}: SortBillingOperationsTvOwner): Observable<void> {
    ctx.patchState({sort: payload.sort, order: payload.order});
    return ctx.dispatch(new GetBillingTvOwnerOperations());
  }

  @Action(SetBillingPageTvOwner)
  setBillingPageTvOwner(ctx: StateContext<BillingStateModel>, {page}: SetBillingPageTvOwner): Observable<void> {
    ctx.patchState({currentPage: page});
    return ctx.dispatch(new GetBillingTvOwnerOperations());
  }

  @Action(GetTvOwnerBalance)
  getTvOwnerBalance(ctx: StateContext<BillingStateModel>): Observable<any> {
    return this.billingService.getTvOwnerBalance()
      .pipe(
        tap((balance) => {
          const state = ctx.getState();
          ctx.setState({...state, balance});
        })
      );
  }
}
